import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Cookie, Shield } from 'lucide-react';
import { Button } from './ui/button';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('akw-cookie-consent');
    if (!cookieConsent) {
      // Small delay for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('akw-cookie-consent', 'all');
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('akw-cookie-consent', 'necessary');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 sm:p-6" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 overflow-hidden">
        <div className="p-6 sm:p-8">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
              <Cookie className="w-6 h-6 text-teal-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-bold text-slate-900 mb-2">
                Cookie-Einstellungen
              </h3>
              <p className="text-slate-600 text-sm leading-relaxed mb-4">
                Wir verwenden technisch notwendige Cookies, um unsere Website funktionsfähig zu halten. 
                Diese Cookies speichern keine personenbezogenen Daten. Weitere Informationen finden Sie 
                in unserer{' '}
                <Link to="/datenschutz" className="text-teal-600 hover:text-teal-700 underline">
                  Datenschutzerklärung
                </Link>.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={acceptAll}
                  className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-6"
                  data-testid="cookie-accept-all"
                >
                  <Shield className="w-4 h-4 mr-2" />
                  Alle akzeptieren
                </Button>
                <Button
                  onClick={acceptNecessary}
                  variant="outline"
                  className="rounded-full px-6"
                  data-testid="cookie-accept-necessary"
                >
                  Nur notwendige Cookies
                </Button>
              </div>
            </div>
            <button
              onClick={acceptNecessary}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              aria-label="Schließen"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
